/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradePreviewGroupChangeSummary } from './moduleUpgradePreviewGroupChangeSummary';

/**
 * Lecturer preview: older published versions sharing the same derived change summary.
 */
export interface ModuleUpgradePreviewGroup {
  versions?: string[];
  changeSummary?: ModuleUpgradePreviewGroupChangeSummary;
}
